<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-cell-group>
            <van-cell title="考级中心/考级点"  label="注册或者关联考级中心考级点信息，获取七彩星级申报业务权限">
                <template #right-icon>
                    <div class="tiny-btn-1" v-if="row.exame_center.kaojiregist_status==0" v-rblink="{name:'QcxjStationCert'}">去认证</div>
                    <div class="tiny-btn-0" v-else-if="row.exame_center.kaojiregist_status==3" v-rblink="{name:'QcxjStationResult'}">认证失败</div>
                    <div class="tiny-btn-0" v-else-if="row.exame_center.kaojiregist_status==1" v-rblink="{name:'QcxjStationResult'}">审核中</div>
                </template>
            </van-cell>
            <van-cell :value="row.exame_center.danwei"  v-if="row.exame_center.kaojiregist_status==2"  >
                <template #icon>
                    <van-tag plain type="success">已认证</van-tag>
                </template>
            </van-cell>

            <div class="bottom-button">
                <van-button round type="default" v-rblink="{name:'ExameApplyList'}">七彩星级运动员申报</van-button>
                <van-button round type="default" v-if="row.exame_center.kaojitype=='考级中心'" v-rblink="{name:'ExameApplySList'}">我授权的申报</van-button>
            </div>
            <van-cell title="我参加的申报"  is-link  v-rblink="{name:'ExameApplyJoinMemberList'}" >  </van-cell>
            <div style="height: 10px"></div>


        </van-cell-group>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button{
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    import {Cell,Field,Dialog,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'StationApply',
        components: {
            PicUploader,
            LoginDialog
        },
        data: function () {
            return {
                validator,
                loginShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{
                    danwei:{

                    },
                    exame_center:{

                    }
                },
                formData: {

                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            this.fetch();
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            fetch(){
                let that = this;
                that.$api.post('/api/user/certindex', {
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    console.log('errrrrr')
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            unbind(){
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '确认要解除单位认证吗?'
                }).then(() => {

                    that.$api.post('/api/danwei/unbind', {
                    }, (res) => {
                        that.fetch();
                    }, (res) => {

                    })

//                    that.onPaySuccess();
                }).catch(() => {
//                    that.onPayError();
                });
            },
            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

        }
    }
</script>



// WEBPACK FOOTER //
// QcxjIndex.vue?e26617c6